import '../scss/style.scss'
import $ from "jquery";
require('jquery.easing');
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import LocomotiveScroll from 'locomotive-scroll';
import Swiper from 'swiper';

gsap.registerPlugin(ScrollTrigger);

let scrollmain;
let offsetMainWrap;
let homeTop,
    gameTop,
    nftTop,
    coinTop,
    tokenTop,
    roadTop,
    teamTop,
    partnerTop;
let oldTop,
    newTop;

function initSmoothScroll() {
    scrollmain = new LocomotiveScroll({
        el: document.querySelector('.scrollmain'),
        smooth: true,
        getDirection: true,
        class: 'is-inview',
        // smartphone: {
        //     smooth: false,
        // }
    });
    scrollmain.on('scroll', ScrollTrigger.update);
    ScrollTrigger.scrollerProxy(".scrollmain", {
        scrollTop(value) {
            return arguments.length ? scrollmain.scrollTo(value, 0, 0) : scrollmain.scroll.instance.scroll.y;
        },
        getBoundingClientRect() {
            return { top: 0, left: 0, width: window.innerWidth, height: window.innerHeight };
        },
        pinType: document.querySelector(".scrollmain").style.transform ? "transform" : "fixed"
    });
    offsetMainWrap = document.querySelector('#main-wrap').offsetTop;
    scrollmain.on('scroll', (instance) => {
        if (instance.scroll.y > offsetMainWrap - 250) {
            $('.mini-header').addClass('scrolled');
        } else {
            $('.mini-header').removeClass('scrolled');
        }
    });
    ScrollTrigger.addEventListener('refresh', () => scrollmain.update());
    ScrollTrigger.refresh();
    setTimeout(() => {
        scrollmain.update();
    }, 500);
    scrollmain.stop();
    $('body').css('overflow', 'hidden');
};
initSmoothScroll();

function activeNav() {
    scrollmain.on('scroll', (instance) => {
        //active section
        $('.menu-link').removeClass('active');
        if (instance.scroll.y < gameTop) {
            $('a[href="#nav-home"]').addClass('active');
        } else if (instance.scroll.y < nftTop) {
            $('a[href="#nav-game"]').addClass('active');
        } else if (instance.scroll.y < coinTop) {
            $('a[href="#nav-nft"]').addClass('active');
        } else if (instance.scroll.y < tokenTop) {
            $('a[href="#nav-coin"]').addClass('active');
        } else if (instance.scroll.y < roadTop) {
            $('a[href="#nav-token"]').addClass('active');
        } else if (instance.scroll.y < teamTop) {
            $('a[href="#nav-road"]').addClass('active');
        } else {
            $('a[href="#nav-team"]').addClass('active');
        }
    })
};
function scrollToNav() {
    $('.menu-link, #scrolltop, .footer-link').on('click', (e) => {
        if ($(e.target).hasClass('external')) {
            console.log('ex');
            return;
        };
        e.preventDefault();
        if ($(window).width() < 991) {
            $('.mb-header').removeClass('open');
            $('.mb-header .menu-toggle').text('Main Menu');
            $('.dropdown-wrap').slideUp(1000, "easeOutExpo");
        }
        let target = $(e.target).attr('href');
        scrollmain.scrollTo(target);
    })
};

function openContract() {
    $('.contract-dropdown').slideUp();
    $('.contract-toggle').on('mouseenter', (e) => {
        e.preventDefault();
        $('.contract-dropdown').slideDown("easeOutExpo");
        $('.social-link-wrap').slideUp(500);
        $(e.target).removeClass('show');
    });
    $('.contract-toggle').on('mouseleave', (e) => {
        e.preventDefault();        
        if ($('.contract-dropdown:hover').length != 1) {
            $('.contract-dropdown').slideUp("easeOutExpo");
        }
    });
    $('.contract-dropdown').on('mouseleave', (e) => {
        e.preventDefault();        
        $('.contract-dropdown').slideUp("easeOutExpo");        
    });
};
openContract();

function openSocialSticky() {
    $('.social-toggle').on('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        $('.social-link-wrap').slideToggle(500);
        $(e.target).toggleClass('show');
    });
    // if ($(window).width() < 991) {
    //     $('.social-link-wrap').slideUp(0);
    //     $('.social-toggle').addClass('show');
    // };
}
openSocialSticky();

function mbMenu() {    
    $('.dropdown-wrap').slideUp();
    $('.menu-toggle').on('click', (e) => {
        e.preventDefault();
        if ($('.mb-header').hasClass('open') != true) {
            $('.mb-header').addClass('open');
            $(e.target).text('Close Menu');
            $('.dropdown-wrap').slideDown(1000, "easeOutExpo");
        } else {
            $('.mb-header').removeClass('open');
            $(e.target).text('Main Menu');
            $('.dropdown-wrap').slideUp(1000, "easeOutExpo");
        }
    })
};
mbMenu();

let counter = 0;
function loading() {
    document.addEventListener('DOMContentLoaded', (event) => {
        if ($(window).width() > 991) {
            gsap.set('.logo-wrap', {
                scale: 0.5,
            })
        } else {
            gsap.set('.logo-wrap', {
                scale: 0.6,
            })
        };
        document.querySelector('#bfLoad').classList.add('is-loaded');
        console.log('domLoaded');
        let countInterval = setInterval((e) => {
            if (counter < 80) {
                counter = counter + 1;
                $('.process-count').text(counter);
                $('.process-cur ').css('width', `${counter}%`);
            };
        }, 30);
    });
};
loading();

function doneLoading() {
    window.addEventListener('load', (event) => {
        console.log('fully loaded');
        let countInterval = setInterval((e) => {
            if (counter >= 80 && counter < 100) {
                counter = counter + 1;
                $('.process-count').text(counter);
                $('.process-cur ').css('width', `${counter}%`);
            } else if (counter >= 100) {
                $('.process-count').text('Welcome');
                clearInterval(countInterval);
                initLoading();
            };
        }, 20);
    });
};
doneLoading();

function initLoading() {
    scrollmain.update();
    oldTop = document.querySelector('.logo-wrap').offsetTop;
    $(this).css('pointer-events', 'none');
    setTimeout(() => {
        //$('.logo-wrap').removeClass('shake');
        hideLoading();
        showbg();
    }, 0);
    //$('.logo-wrap').addClass('shake');
    setTimeout(() => {
        $('.schero-home, #main-wrap, .mini-header, .header').removeClass('loading-wrap');
        $('.scgame-home').removeClass('loading-wrap');
        newTop = oldTop - document.querySelector('.logo-wrap').offsetTop;
        revealHero(newTop);
        homeTop = document.querySelector('.schero-home').offsetTop;
        gameTop = document.querySelector('.schero-home').clientHeight;
        nftTop = gameTop + document.querySelector('.scgame-home').clientHeight;
        if ($(window).width() > 512) {
            coinTop = nftTop + document.querySelector('.scnft-home').clientHeight + 1600;
        } else {
            coinTop = nftTop + document.querySelector('.scnft-home').clientHeight;
        }
        tokenTop = coinTop + document.querySelector('.sccoin-home').clientHeight;
        roadTop = tokenTop + document.querySelector('.sctoken-home').clientHeight;
        teamTop = roadTop + document.querySelector('.scroad-home').clientHeight;
        partnerTop = teamTop + document.querySelector('.scteam-home').clientHeight;
        offsetMainWrap = document.querySelector('#main-wrap').offsetTop;
    }, 300);
    setTimeout(() => {
        scrollmain.update();
        scrollmain.start();
        $('body').css('overflow', 'auto');
        activeNav();
        scrollToNav();
        flyCloud();
        if ($(window).width() < 991) {
            $('.mb-header').addClass('show');
        }
    }, 300);
    //document.querySelector('audio').volume = 0;
    //$('.music-ic-wrap').addClass('off');
    //document.querySelector('audio').play();

    $('.music-trigger').on('click', (e) => {
        document.querySelector('audio').volume = 0.5;
        e.preventDefault();
        if ($('.music-ic-wrap').hasClass('off')) {
            $('.music-ic-wrap').removeClass('off');
            document.querySelector('audio').play();
        } else {
            $('.music-ic-wrap').addClass('off');
            document.querySelector('audio').pause();
        }
    });

    function showbg() {
        const tlShowBg = gsap.timeline();
        tlShowBg
            .to('.schero-home .bg', {
                opacity: 1,
                duration: 1.1,
            })
            .to('.schero-home .bg-wrap', {
                opacity: 1,
                duration: 1.1,
            }, '0');
    };

    function hideLoading() {
        const tlhideLoad = gsap.timeline();
        tlhideLoad
            .to('.schero-home .logo-wrap', {
                scale: 0.4,
                duration: 0.3,
                ease: "none",
                y: 20,
            })
            .to('.schero-home .processbar-wrap', {
                y: -50,
                autoAlpha: 0,
                duration: 0.3,
            }, '0')
            .to('.schero-home .text-loading', {
                y: -50,
                autoAlpha: 0,
                duration: 0.3,
            }, '0');
    };

    function revealHero(theTop) {
        const tlrevealHero = gsap.timeline({
            onComplete: () => {
                scrollmain.update();
                // document.querySelector('.char-cra').play();
                // document.querySelector('.char-kni').play();
                // document.querySelector('.char-dog').play();
                // document.querySelector('.char-rab').play();
                document.querySelector('.token-ele video').play();
                scNft();
            }
        })
        tlrevealHero
            .from('.header', {
                yPercent: -100,
                autoAlpha: 0,
            })
            .fromTo('.logo-wrap', {
                y: theTop + 20,
                scale: 0.4,
                duration: .8,
            }, {
                scale: 1,
                y: 0,
            }, '0')
            .from('.char-dog', {
                x: 300,
                y: 300,
                autoAlpha: 0,
                duration: 0.8,
                delay: 0.2,
            }, '0')
            .from('.char-kni', {
                x: -300,
                y: 300,
                autoAlpha: 0,
                duration: 0.8,
                delay: 0.2,
            }, '0')
            .from('.char-rab', {
                x: 200,
                y: 200,
                autoAlpha: 0,
                duration: .8,
                delay: 0.1,
            }, '0')
            .from('.char-cra', {
                x: -200,
                y: 200,
                autoAlpha: 0,
                duration: .8,
                delay: 0.1,
            }, '0')
            .from('.rock-left-1', {
                x: 300,
                y: 200,
                autoAlpha: 0,
                duration: .8,
                delay: 0.3,
            }, '0')
            .from('.rock-right-1', {
                x: -160,
                y: 120,
                autoAlpha: 0,
                duration: .8,
                delay: 0.1,
            }, '0')
            .from('.rock-right-2', {
                x: -300,
                y: 200,
                autoAlpha: 0,
                duration: .8,
                delay: 0.3,
                clearProps: "all",
            }, '0')
            .from('.schero-home .--h1', {
                y: 200,
                autoAlpha: 0,
                duration: .8,
                delay: 0.08,
                clearProps: "all",
            }, '0')
            .from('.schero-home .text-hero', {
                y: 200,
                duration: .8,
                autoAlpha: 0,
                delay: 0.16,
                clearProps: "all",
            }, '0')
            .from('.schero-home .btn-pitch', {
                y: 200,
                autoAlpha: 0,
                duration: .8,
                delay: 0.24,
                clearProps: "all",
            }, '0')
            .from('.schero-home .contract-wrap', {
                y: 200,
                autoAlpha: 0,
                duration: .8,
                delay: 0.32,
            }, '0')
            .to('.social-sticky', {
                x: 0,
                duration: .8,
                delay: 0.24,
            }, '0');
    };
    function flyCloud() {
        // gsap.set(".far-item", {
        //     x: (i) => i * (window.innerWidth),
        // });
        // gsap.to(".far-item", {
        //     duration: 70,
        //     ease: "none",
        //     x: "+=3840",
        //     modifiers: {
        //         x: gsap.utils.unitize(x => parseFloat(x) % 3840)
        //     },
        //     repeat: -1
        // });
        // gsap.set(".close-item", {
        //     x: (i) => i * (window.innerWidth),
        // });
        // gsap.to(".close-item", {
        //     duration: 140,
        //     ease: "none",
        //     x: "+=3840",
        //     modifiers: {
        //         x: gsap.utils.unitize(x => parseFloat(x) % 3840)
        //     },
        //     repeat: -1
        // });
        // gsap.set(".near-item", {
        //     x: (i) => i * (window.innerWidth),
        // });
        // gsap.to(".near-item", {
        //     duration: 30,
        //     ease: "none",
        //     x: "+=3840",
        //     modifiers: {
        //         x: gsap.utils.unitize(x => parseFloat(x) % 3840)
        //     },
        //     repeat: -1
        // });
    };
};

function magicCursor() {
    const cursor = $('.cursor-wrap');
    document.addEventListener('mousemove', (e) => {
        cursor.css({
            'top': `${e.pageY}px`,
            'left': `${e.pageX}px`
        });
        $('.cursor-skip').css({
            'top': `${e.pageY}px`,
            'left': `${e.pageX}px`
        });
    });
    $('.scteam-home .slide-team').on('mouseover', e => {
        if ($('.scteam-home .slide-team .linkedin-wrap:hover').length) {
            cursor.removeClass('show');
        } else {
            cursor.addClass('show');
        }
    });
    $('.scteam-home .slide-team').on('mouseleave', e => {
        cursor.removeClass('show');
    });
    // $('.scnft-home').on('mouseenter', e => {
    //     $('.cursor-skip').addClass('show');
    // });
    // $('.scnft-home').on('mouseleave', e => {
    //     $('.cursor-skip').removeClass('show');
    // });
    // $('.cursor-skip').on('click', (e) => {
    //     e.preventDefault();
    //     e.stopPropagation();
    //     scrollmain.scrollTo('#nav-coin')
    // })
}
magicCursor();

function copyText(address) {
    //getting text from P tag
    let copyText = document.getElementById(address);
    // creating textarea of html
    let input = document.createElement("textarea");
    //adding p tag text to textarea 
    input.value = copyText.textContent;
    document.body.appendChild(input);
    input.select();
    document.execCommand("Copy");
    console.log(input.value);
    // removing textarea after copy
    input.remove();
}
$('#Btn01').on('click', (e) => {
    e.preventDefault();
    copyText("Add01");
    $('#Btn01 span').text('Copied');
    setTimeout(() => {
        $('#Btn01 span').text('Copy XXX20');
    }, 5000);
});
$('#Btn02').on('click', (e) => {
    e.preventDefault();
    copyText("Add01");
    $('#Btn02 span').text('Copied');
    setTimeout(() => {
        $('#Btn02 span').text('Copy XXX20');
    }, 5000);
});
$('#Btn01Hero').on('click', (e) => {
    e.preventDefault();
    copyText("Add01Hero");
    $('#Btn01Hero .text-12').text('Copied');
    setTimeout(() => {
        $('#Btn01Hero .text-12').text('Copy');
    }, 5000);
});
$('#Btn02Hero').on('click', (e) => {
    e.preventDefault();
    copyText("Add02Hero");
    $('#Btn02Hero .text-12').text('Copied');
    setTimeout(() => {
        $('#Btn02Hero .text-12').text('Copy');
    }, 5000);
});

$('[data-soon]').on('click', (e) => {
    e.preventDefault();
    console.log('coming soon');
    gsap.set('.soon-item', {yPercent: 300, autoAlpha: 0});
    gsap.to('.soon-item', {yPercent: 0, autoAlpha: 1, duration: 2});
    gsap.to('.soon-item', {yPercent: 0, autoAlpha: 0, duration: .4, delay: 1.6});
})

function scGame() {
    // document.querySelector('video.game-img[data-game="game1"]').play();
    $('.game-item-qn').on('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        let gameTarget = $(e.target).data('game');
        $('.game-item').removeClass('active');
        $(e.target).parent('.game-item').addClass('active');
        $('.game-item-an').stop().slideUp(200);
        $(e.target).closest('.game-item').find('.game-item-an').stop().slideDown(200);
        $('.game-img').removeClass('active');
        $('.game-vid').removeClass('active');
        $('[data-game=' + gameTarget + ']').addClass('active');
        setTimeout(() => {
            ScrollTrigger.getById("triggerNft").kill(true);
            scNft();
            scrollmain.update();
        }, 200);
        setTimeout(() => {
            scrollmain.update();
        }, 400);
    })
};
scGame();

function scNft() {
    if ($(window).width() > 990) {
        let large = document.querySelector('.fg-ground').offsetWidth;
        let small = window.innerWidth;
        let offsetw = small - large;
        console.log(offsetw);
        let tlNft = gsap.timeline({
            scrollTrigger: {
                id: 'triggerNft',
                trigger: '.scnft-home',
                scroller: '.scrollmain',
                start: 'top top',
                end: '+=2000',
                pin: true,
                scrub: true,
                pinSpacing: true,
            }
        });
        tlNft.to('.nft-fg-wrap', {
            x: offsetw,
            ease: "none",
        })
            .to('.nft-bg-far img', {
                x: '2vw',
                ease: "none",
            }, 0)
            .to('.nft-fg-near img', {
                x: '-3vw',
                y: 0,
                ease: "none",
            }, 0)
            .to('.nft-bg-near .nft-tree-l-1', {
                x: "-6vw",
                ease: "none",
            }, 0)
            .to('.nft-bg-near .nft-tree-r-1', {
                x: "-5.5vw",
                ease: "none",
            }, 0)
            .to('.nft-bg-near .nft-tree-l-2', {
                x: "-1.5vw",
                ease: "none",
            }, 0)
            .to('.nft-bg-near .nft-tree-r-2', {
                x: "-2vw",
                ease: "none",
            }, 0);
        let tlBottom = gsap.timeline({
            scrollTrigger: {
                trigger: '.sccoin-home',
                scroller: '.scrollmain',
                start: 'top bottom',
                end: 'top +=500',
                scrub: true,
            }
        });
        tlBottom
            .to('.nft-fg-near img', {
                y: -120,
                ease: "none",
            })
            .to('.nft-fg-near-cover', {
                y: -120,
                ease: "none",
            }, 0);
        setTimeout(() => {
            scrollmain.update()
        }, 500);

        $('.menu-link, #scrolltop, .footer-link').on('click', (e) => {
            if ($(e.target).hasClass('external')) {
                console.log('ex');
                return;
            };
            e.preventDefault();
            if ($(window).width() < 991) {
                $('.mb-header').removeClass('open');
                $('.mb-header .menu-toggle').text('Main Menu');
                $('.dropdown-wrap').slideUp(1000, "easeOutExpo");
            }
            let target = $(e.target).attr('href');
            scrollmain.scrollTo(target);
        });

        $('[data-skip]').on('click', (e) => {
            e.preventDefault();
            scrollmain.scrollTo('#nav-coin');
        });

    } else {
        const nftSwiper = new Swiper('.fg-nft-wrap', {
            slidesPerView: 1,
            spaceBetween: 8,
        })
    }

};

function scTeam() {
    const teamSwiper = new Swiper('.slide-team', {
        slidesPerView: 1,
        spaceBetween: 28,
        breakpoints: {            
            575: {
                slidesPerView: 2,
                spaceBetween: 64,
            },
            768: {
                slidesPerView: 3,
                spaceBetween: 64,
            },
            991: {
                slidesPerView: 4,
                spaceBetween: 64,
            }
        }
    });
    
    const teamAdvSwiper = new Swiper('.slide-advisor', {
        slidesPerView: 1,
        spaceBetween: 28,
        breakpoints: {            
            575: {
                slidesPerView: 2,
                spaceBetween: 64,
            },
            768: {
                slidesPerView: 1,
                spaceBetween: 64,
            },
            991: {
                slidesPerView: 1,
                spaceBetween: 64,
            }
        }
    })
};
scTeam();



